export const getters = {
    getAvailableSvgFiles: state => state.availableSvgFiles,
    getFilterFromState: (state) => (id) => {
        return state.uiFilters.find((d) => {
            return (d.id === id);
        });
    },
    getLocale: state => state.userInfo.locale
};
